'use client'

import { BloodCollectionDetail } from '@/features/blood-collection-detail'
import {
  useIsDonorCardReadOnly,
  useIsVisitClosed,
} from '../model/use-donor-card-read-only'

interface Props {
  visitId: string
}

export function BloodCollectionTab({ visitId }: Props) {
  const readOnly = useIsDonorCardReadOnly(visitId)
  // A finished visit rejects every collection write (complete, reject, analyses).
  const visitClosed = useIsVisitClosed(visitId)
  return (
    <BloodCollectionDetail
      collectionStageId={visitId}
      readOnly={readOnly || visitClosed}
    />
  )
}
